module.exports = __webpack_public_path__ + "static/adv2-b014bc3265cc1dd78fc822dc3bd180c5.png";